/** Заставка першого завантаження сторінки гостя зустрічі — без позначок внутрішньої системи. */
export function GuestLoading() {
  return (
    <div role="status" aria-label="Завантаження запрошення" className="flex min-h-dvh items-center justify-center bg-canvas px-4">
      <span className="text-meta text-fg-3">Завантаження запрошення…</span>
    </div>
  );
}
